import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
function SvgComponent() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M30.5976 57.764H23.5C22.3954 57.764 21.5 56.8685 21.5 55.764L21.5 18.5C21.5 17.3954 22.3954 16.5 23.5 16.5L44.0704 16.5C44.58 16.5 45.0704 16.6957 45.4414 17.0471L54.871 25.9788C55.2724 26.359 55.5 26.889 55.5 27.4436V56.032C55.5 57.1457 54.5902 58.0449 53.4766 58.0319L30.5976 57.764Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 55.5C16.9477 55.5 16.5 55.0523 16.5 54.5V13.5C16.5 12.3954 17.3954 11.5 18.5 11.5H39.0534C39.6529 11.5 40.2298 11.7324 40.6663 12.1497L51.76 22.7558C52.2323 23.2073 52.5 23.8367 52.5 24.4953V25.4861V53.5C52.5 54.6046 51.6046 55.5 50.5 55.5H17.5ZM50.167 23.5996L41.4883 15.3367V22.4977C41.4883 23.0448 41.928 23.4903 42.475 23.4976L50.167 23.5996ZM39.5891 13.5285V23.4845C39.5891 24.4995 40.4046 25.4861 41.4883 25.4861H50.5V52.5007C50.5 53.053 50.0523 53.5007 49.5 53.5007H19.5C18.9477 53.5007 18.5 53.053 18.5 52.5007V14.4995C18.5 13.9472 18.9477 13.4995 19.5 13.4995H39.5586L39.5891 13.5285Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: "21.5",
    y: "23.5",
    width: "10",
    height: "2",
    rx: "1",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: "21.5",
    y: "29.5",
    width: "14",
    height: "2",
    rx: "1",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: "57.8892",
    y: "51.2678",
    width: "3",
    height: "8",
    rx: "1",
    transform: "rotate(135 57.8892 51.2678)",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 49.5C50.6944 49.5 54.5 45.6944 54.5 41C54.5 36.3056 50.6944 32.5 46 32.5C41.3056 32.5 37.5 36.3056 37.5 41C37.5 45.6944 41.3056 49.5 46 49.5Z",
    fill: "white",
    stroke: "#BDBDBD",
    strokeWidth: "2"
  }));
}
export default SvgComponent;